module.exports = __webpack_public_path__ + "static/media/A5-portrait-v2.38943e5f.png";